import { render } from "./Gemini.vue?vue&type=template&id=65852150&scoped=true"
import script from "./Gemini.vue?vue&type=script&lang=js"
export * from "./Gemini.vue?vue&type=script&lang=js"

import "./Gemini.vue?vue&type=style&index=0&id=65852150&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65852150"]])

export default __exports__